import { SpeedTest } from "@/components/SpeedTest";

const Index = () => {
  return <SpeedTest />;
};

export default Index;
